import * as React from "react";
import { forwardRef } from "react";
const SvgLeftArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 20, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M.004 9.984c0-.333.115-.656.328-.912L7.462.515A1.428 1.428 0 0 1 9.66 2.341l-6.39 7.643 6.161 7.644a1.425 1.425 0 0 1-.214 2.01 1.426 1.426 0 0 1-2.082-.199L.246 10.883a1.43 1.43 0 0 1-.242-.899" }));
const ForwardRef = forwardRef(SvgLeftArrow);
export { ForwardRef as ReactComponent };
